<template>
  <svg
    class="brand-logo-icon"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    :stroke="`url(#${gradientId})`"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <defs>
      <linearGradient :id="gradientId" x1="2" y1="2" x2="22" y2="22" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stop-color="var(--mc-logo-grad-start)" />
        <stop offset="55%" stop-color="var(--mc-logo-grad-mid)" />
        <stop offset="100%" stop-color="var(--mc-logo-grad-end)" />
      </linearGradient>
    </defs>
    <template v-if="variant === 'monitor'">
      <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
      <line x1="8" y1="21" x2="16" y2="21" />
      <line x1="12" y1="17" x2="12" y2="21" />
    </template>
    <template v-else>
      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
      <polyline points="9 22 9 12 15 12 15 22" />
    </template>
  </svg>
</template>

<script setup>
import { useId } from 'vue'

defineProps({
  size: { type: [Number, String], default: 28 },
  variant: {
    type: String,
    default: 'home',
    validator: (v) => ['home', 'monitor'].includes(v),
  },
})

const gradientId = `mc-brand-grad-${useId().replace(/:/g, '')}`
</script>

<style scoped>
.brand-logo-icon {
  flex-shrink: 0;
  display: block;
}
</style>
